'use client';

import { AUTH_LOGIN_PAGE_PATH } from '~/app/pages';
import { REDIRECT_PATH_SEARCH_PARAM_NAME } from '~/constants';

export default function redirectToLogin() {
  const searchParams = new URLSearchParams(document.location.search);

  searchParams.set(REDIRECT_PATH_SEARCH_PARAM_NAME, document.location.pathname);

  const queryString = searchParams.toString();

  document.location.replace(
    `${AUTH_LOGIN_PAGE_PATH}${queryString && `?${queryString}`}`,
  );
}
